import { render, staticRenderFns } from "./UnitsWidget.vue?vue&type=template&id=46a2bc7e"
import script from "./UnitsWidget.vue?vue&type=script&lang=js"
export * from "./UnitsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports